/* eslint-disable no-empty -- TDOD: fix me, do not replicate */

import { usePathname, useSearchParams } from "next/navigation";

import publicConfig from "@/config/public";
import sanitizePage from "@/utils/sanitizePage";

const { leaflyDomain, leaflyCaDomain } = publicConfig;

export default (omitPageQuery?: boolean): { caUrl: string; usUrl: string } => {
  const basePath = usePathname() || "";
  const searchParams = useSearchParams();
  const page = searchParams?.get("page");
  const letter = searchParams?.get("letter");

  let usUrl;
  try {
    usUrl = new URL(basePath, leaflyDomain);
  } catch {}

  let caUrl;
  try {
    caUrl = new URL(basePath, leaflyCaDomain);
  } catch {}

  if (page) {
    const pageNumber = sanitizePage(page);

    if (Number(pageNumber) > 1 && !omitPageQuery) {
      if (usUrl) {
        usUrl.searchParams.set("page", `${pageNumber}`);
      }
      if (caUrl) {
        caUrl.searchParams.set("page", `${pageNumber}`);
      }
    }
  }

  // letter is used on cannabis glossary pages
  if (basePath === "/learn/cannabis-glossary") {
    if (usUrl) {
      usUrl.searchParams.set("letter", `${letter || "a"}`);
    }

    if (caUrl) {
      caUrl.searchParams.set("letter", `${letter || "a"}`);
    }
  }

  return { caUrl: `${caUrl}`, usUrl: `${usUrl}` };
};

/* eslint-enable no-empty -- TDOD: fix me, do not replicate */
